import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a77a1cc8295d500147f4bd9_1786410732712_674f1bb3/detailvault_1786225099956/src/app/about/page.tsx");
